import { render, staticRenderFns } from "./collapse-all.vue?vue&type=template&id=e4ded154"
import script from "./collapse-all.vue?vue&type=script&lang=js"
export * from "./collapse-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports